import { createFileRoute } from "@tanstack/react-router";

import { PatientSyncPage } from "@/uiKit/pages/PatientSyncPage.tsx";

export const Route = createFileRoute("/_practitioner/patient-sync/")({
  component: PatientSyncPage,
});
